import { useQuery } from "react-query";
import { api } from "src/services/api";

export const useValidateTagOffer = (tagNumber) => {
  const codPromocional = "VELOEGWMPRE";

  return useQuery(
    "validateTagOffer",
    () =>
      api
        .get(`/publico/validar/${tagNumber}/identificador/${codPromocional}`)
        .then((res) => res.data),
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  );
};
